import MembersDashboard from "./_components/MembersDashboard";

export default function HomeMembersPage() {
  return <MembersDashboard />;
}
